import React from 'react';
import Main from './Components/Main';
import './Style.scss';
import Header from './Header/Header';

function App() {
  return (
    <>
      <Header />
      <Main />
    </>
  );
}

export default App;
